<div class="flex flex-col gap-3">
  <div class="flex items-center justify-between">
    <h1 class="text-primary text-2xl font-bold" i18n="@@adminParentProducts">Products</h1>
    <a
      routerLink="/admin/products/add-product"
      class="add-button flex items-center justify-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
      </svg>
      <span *hasScope="SCOPES.PRODUCTS.CREATE" i18n="@@product.page.title">Add Product</span>
    </a>
  </div>
  <div class="mb-4 rounded-2xl pb-[16px]">
    <app-admin-products-list />
  </div>
</div>
